import { Separator } from '@radix-ui/react-select';
import { cn } from 'cn';

interface Props extends React.ComponentPropsWithoutRef<typeof Separator> {
  ref?: React.Ref<React.ElementRef<typeof Separator>>;
}

/**
 * @deprecated Use `SelectSeparator` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function SelectSeparator({ className, ref, ...props }: Props) {
  return (
    <Separator
      data-test='select-separator'
      ref={ref}
      className={cn('-mx-1 my-1 h-px', className)}
      {...props}
    />
  );
}

export default SelectSeparator;
